// Shared across Basket/show.latte, Order/transaction.latte and Order/delivery.latte - all
// three include the same _order-sum.latte sticky bar (for steps 1-3 of checkout).
$(document).ready(function () {
	// Mobile-only sticky checkout bar: copies the price and moves the quick-purchase trigger,
	// keeping the summary price and CTA in place and forwarding sticky clicks to the CTA.
	// #cart-sticky-bar (see _order-sum.latte) lives inside {snippet orderSum}, so it (and the
	// price/button nodes) get freshly re-rendered by the server on every recount - this must
	// re-run on ajaxComplete too, not just once on load and on resize.
	var buyObserver = null;
	function initMobileStickyBar() {
		if (buyObserver) buyObserver.disconnect();
		var $stickyBar = $('#cart-sticky-bar');
		var $price = $('#cart-price-mobile');
		var $buyWrap = $('#cart-buy-wrap');
		var $quickPurchaseWrap = $('.js-cart-quick-purchase-wrap');
		var hasQuickPurchase = $quickPurchaseWrap.length > 0;
		if (!$stickyBar.length || !$buyWrap.length) return;

		// each moved node gets a placeholder left in its original spot, so switching
		// back to desktop can put it back exactly where it came from
		function getAnchor($node) {
			if (!$node.length) return null;
			var $anchor = $node.data('cartStickyAnchor');
			if (!$anchor) {
				$anchor = $('<span class="d-none js-sticky-anchor"></span>').insertBefore($node);
				$node.data('cartStickyAnchor', $anchor);
			}
			return $anchor;
		}
		// ajaxComplete can run without replacing orderSum. Reuse the original anchors
		// so hidden placeholders do not enter the bar and break its only-child layout.
		// Refresh the copy after every recount without duplicating IDs or removing the summary price.
		$stickyBar.find('.js-cart-sticky-price').remove();
		var $stickyPrice = $price.clone()
			.removeAttr('id')
			.find('[id]').removeAttr('id').end()
			.addClass('js-cart-sticky-price');
		var $quickPurchaseAnchor = getAnchor($quickPurchaseWrap);
		var $buyButton = $buyWrap.find('button').first();
		var $stickyBuyWrap = $stickyBar.find('.js-cart-sticky-buy-wrap');
		if (!$stickyBuyWrap.length) {
			$stickyBuyWrap = $buyWrap.clone()
				.removeAttr('id')
				.find('[id]').removeAttr('id').end()
				.addClass('js-cart-sticky-buy-wrap');
			$stickyBuyWrap.find('button')
				.prop('type', 'button')
				.removeAttr('name form onclick')
				.removeClass('js-order-success order-btn-next btn-loading');
			$stickyBar.append($stickyBuyWrap);
		}
		var $stickyBuyButton = $stickyBuyWrap.find('button').first();
		function syncBuyButton() {
			$stickyBuyButton.html($buyButton.html())
				.attr('class', $buyButton.attr('class'))
				.removeClass('js-order-success order-btn-next btn-loading btn-shop')
				.addClass('btn-dark btn-shop-colors')
				.attr('style', $buyButton.attr('style') || '')
				.prop('disabled', $buyButton.prop('disabled'))
				.toggleClass('disabled', $buyButton.hasClass('disabled'));
		}
		syncBuyButton();
		$stickyBuyButton.off('click.cartStickyBuy').on('click.cartStickyBuy', function (e) {
			e.preventDefault();
			if (!$buyButton.prop('disabled') && !$buyButton.hasClass('disabled')) {
				$buyButton[0].click();
				syncBuyButton();
			}
		});
		// Payment selection and loading states change the original button without
		// necessarily replacing the summary snippet. Keep the sticky copy in sync.
		if (window.MutationObserver && $buyButton.length) {
			buyObserver = new MutationObserver(syncBuyButton);
			buyObserver.observe($buyButton[0], {
				attributes: true,
				attributeFilter: ['disabled', 'class', 'style'],
				childList: true,
				characterData: true,
				subtree: true
			});
		}

		var mobileActive = null; // null = not synced yet

		function enableMobile() {
			if (mobileActive === true) return;
			mobileActive = true;

			if ($stickyPrice.length) $stickyBar.append($stickyPrice);
			if (hasQuickPurchase) $stickyBar.append($quickPurchaseWrap);
			$stickyBar.append($stickyBuyWrap);
			$stickyBar.toggleClass('cart-price-buy-bar--with-quick-purchase', hasQuickPurchase);
			$stickyBar.removeClass('d-none');
		}

		function enableDesktop() {
			if (mobileActive === false) return;
			mobileActive = false;

			$stickyBar.addClass('d-none');
			if (hasQuickPurchase) $quickPurchaseWrap.insertAfter($quickPurchaseAnchor);
		}

		function syncLayout() {
			if (window.innerWidth >= 992) {
				enableDesktop();
			} else {
				enableMobile();
			}
		}

		syncLayout();

		// re-bound (not stacked) on every call, so a later ajaxComplete resync always
		// debounces against the current DOM nodes instead of a stale pre-recount snapshot
		var resizeTimer;
		$(window).off('resize.cartStickyBar').on('resize.cartStickyBar', function () {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(syncLayout, 150);
		});
	}
	initMobileStickyBar();

	$(document).on('ajaxComplete', function () {
		initMobileStickyBar();
	});
});
